import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const pixelId = '2111648319658742';
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-truco-dark text-truco-cream selection:bg-truco-gold selection:text-truco-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <Footer data-id="element-10" />

      {/* Interactive Overlays */}
      <PurchasePopup data-id="element-11" />
      <FloatingCTA data-id="element-12" />
    </div>;
}